// SoundContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import { useAuth } from '../AuthContext';

const SoundContext = createContext();

export const SoundProvider = ({ children }) => {
    const [soundEnabled, setSoundEnabled] = useState(true);
    const { isAdmin } = useAuth();

    const toggleSound = () => {
        // If turning on, always allow
        if (!soundEnabled) {
            setSoundEnabled(true);
        }
        // If turning off, only allow for admin
        else if (isAdmin()) {
            setSoundEnabled(false);
        }
    };

    return (
        <SoundContext.Provider value={{ soundEnabled, toggleSound }}>
            {children}
        </SoundContext.Provider>
    );
};

export const useSound = () => useContext(SoundContext);